import excelAnalytics from '@/store/modules/excel/excel-analytics'
import excelCalendarPlan from '@/store/modules/excel/excel-calendar-plan'
import excelUserReports from '@/store/modules/excel/excel-user-reports'
import excelTariffs from '@/store/modules/excel/excel-tariffs'
import excelApplicationsReporting from '@/store/modules/excel/excel-applications-reporting'

export default {
  excelAnalytics,
  excelCalendarPlan,
  excelUserReports,
  excelTariffs,
  excelApplicationsReporting,
}
